<template>
  <div v-if="site" class="padded progress-detail">

    <el-row v-if="rowData.siteName || rowData.siteId || !site.address">
      <el-col :span="24">
        <h1 v-if="rowData.siteName">{{rowData.siteName}}</h1><template v-if="rowData.siteName && rowData.siteId">&nbsp;</template><h4 v-if="rowData.siteId">{{rowData.siteId}}</h4>
        <span v-if="!site.address">Council&nbsp;<strong>{{site.zone}}</strong></span>
      </el-col>

    </el-row>

    <el-row>
      <el-col :span="12">
        <i>{{site.subdistrict}}</i> <i v-if="site.district"><span v-if="site.subdistrict">, </span>{{site.district}}</i>
        <i v-if="site.region"><span v-if="site.district || site.subdistrict">, </span>{{site.region}}</i>
        <i v-if="site.state"><span v-if="site.district || site.subdistrict || site.region">, </span>{{site.state}}</i>
        <i v-if="site.country"><span v-if="site.district || site.subdistrict || site.region || site.state">, </span>{{site.country}}</i>
      </el-col>
    </el-row>

    <el-row v-if="site.address">
      <el-col :span="14">
        <strong>{{site.address}}</strong>&nbsp;&nbsp;
        Local Council&nbsp;<strong>{{site.zone}}</strong>
      </el-col>

      <el-col :span="10">
        <small>lat:</small>&nbsp;<strong>{{site.latitude}}</strong> / <small>lng:</small>&nbsp;<strong>{{site.longitude}}</strong>
      </el-col>
    </el-row>

    <el-tabs v-if="!isEmptyObject(action)" v-model="step" type="card" @tab-click="tabClicked" stretch>
<!--
      <el-tab-pane>

      <template #label><span><i class="fa fa-list"></i> Summary</span></template>

       <progress-summary title="New Submission" v-model="action.steps[0]" />

       <progress-summary title="New Site" v-model="action.steps[1]" />

       <progress-summary title="Renewal" v-model="action.steps[2]" />

     </el-tab-pane>
-->
      <el-tab-pane :name="slugify(action.steps[0].stepName)">
        <template #label><span><i class="fa fa-file"></i> {{action.steps[0].stepName}}</span></template>
        <progress-step1 :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[0]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane :name="slugify(action.steps[1].stepName)" lazy>
        <template #label><span><i class="fa fa-edit"></i> {{action.steps[1].stepName}}</span></template>
        <Progress-step2 :site-id="rowData.site_id" :row-data="action"  :step-data="action.steps[1]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane :name="slugify(action.steps[2].stepName)" lazy>
        <template #label><span><i class="fa fa-list"></i> {{action.steps[2].stepName}}</span></template>
        <progress-step3  :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[2]" :read-only="true" />
      </el-tab-pane>

      <el-tab-pane :name="slugify(action.steps[3].stepName)" lazy>
        <template #label><span><i class="fa fa-recycle"></i> {{action.steps[3].stepName}}</span></template>
        <progress-step4  :site-id="rowData.site_id" :row-data="action" :step-data="action.steps[3]" :read-only="true" />
      </el-tab-pane>



      <el-tab-pane name="land-owner" lazy>
        <template #label><span><i class="fa fa-home"></i> Land Owner</span></template>
        <el-row>
          <el-col :span="14">
            <h2>Land Owner</h2>

            <div v-if="!hasLandowner(site)">
              <center>
                <h3 class="subtitle">No landowner information found</h3>
              </center>
            </div>
            <div v-else>
              <el-row>
                <el-col :span="4">
                  Owner
                </el-col>

                <el-col :span="20">
                  <strong>{{site.tenancy.owner.name}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Address
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.address}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Post Code
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.postCode}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  Phone
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.phone}}</strong>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  e-Mail
                </el-col>
                <el-col :span="20">
                  <strong>{{site.tenancy.owner.email}}</strong>
                </el-col>
              </el-row>

            </div>
            <br />
            <table v-if="site.landStarted" class="el-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tfoot>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{site.landType}} Agreement</td>
                  <td><strong :class="isOverdue(site.landExpiry) ? 'text-primary' : 'text-success'">{{formatDate(site.landStarted)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Deposit Paid</td>
                  <td></td>
                  <td>{{formatNumber(site.landDeposit)}}</td>
                </tr>
                <tr>
                  <td>{{site.frequency}} Rental</td>
                  <td></td>
                  <td>{{formatNumber(site.landPayment)}}</td>
                </tr>
                <tr>
                  <td>Agreement Expiry</td>
                  <td><strong :class="isOverdue(site.landExpiry) ? 'text-warning' : 'text-primary'">{{formatDate(site.landExpiry)}}</strong> <i>({{formatFriendlyDate(site.landExpiry)}})</i></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Renewal Increment</td>
                  <td>
                    <span v-if="site.term">
                      <strong>{{site.term}}</strong>
                      {{site.term > 1 ? 'times' : 'time'}}
                    </span>
                  </td>
                  <td><strong>{{formatNumber(site.renewalIncrement)}}</strong> %</td>
                </tr>
              </tbody>
            </table>

          </el-col>

    </el-row>
  </el-tab-pane>
<!--
  <el-tab-pane lazy>
    <template #label><span><i class="fa fa-users"></i> Sharers</span></template>
    <site-sharers :no-add="true" :read-only="true" :row-data="rowData"></site-sharers>
  </el-tab-pane>
-->
</el-tabs>
<hr>

<el-row>
  <el-col :span="8">
    <small  v-if="site.handover">Handover </small>&nbsp;
    <strong v-if="site.handover">{{formatDate(site.handover)}}</strong>
    </el-col

    <el-col :span="7" :offset="1">
      <small v-if="site.landExpiry">Land Expiry </small>&nbsp;
      <strong  v-if="site.landExpiry">{{formatDate(site.landExpiry)}}</strong>
    </el-col>

    <el-col :span="7" :offset="1">
      &nbsp;<small v-if="site.billing">Agreement Start</small>
      <strong v-if="site.billing">{{formatDate(site.billing)}}</strong>
    </el-col>

  </el-row>


</div>
</template>

<script>

import PermitMixins from '@/mixins/PermitMixins'

import SiteSharers from '@/components/sites/SiteSharers'
import LandAgreement from '@/components/property/LandAgreement'

import ProgressSummary from '@/components/progress/ProgressSummary'

import ProgressStep1 from '@/components/progress/ProgressStep1'
import ProgressStep2 from '@/components/progress/ProgressStep2'
import ProgressStep3 from '@/components/progress/ProgressStep3'
import ProgressStep4 from '@/components/progress/ProgressStep4'

import { replaceDrawerArgs } from '@/lib/layerNav'

export default {
  mixins: [PermitMixins],

  components: {
    ProgressSummary,
    SiteSharers,
    LandAgreement,
    ProgressStep1,
    ProgressStep2,
    ProgressStep3,
    ProgressStep4
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    // Route-driven active el-tab slug when rendered inside the progress drawer
    // (step1..step4 / landowner). null when rendered inline (ProgressReport /
    // ProgressAction), where it falls back to the first tab.
    tab: {
      type: String,
      default: null
    }
  },

  watch: {
    // Deep-link / back-button: realign the active tab when the URL tab changes.
    tab: function (val) {
      if (val && val !== this.step) {
        this.step = val
      }
    }
  },

  methods: {
    fillSite (data) {
      this.site = data
    },

    fillStep (data) {
      this.action = data
      // el-tab-pane names are slugs of the visible tab text (so the drawer URL
      // reads d.progress.<id>.submission rather than .step2). Resolve the active
      // tab once the steps are known: honour the route slug if it matches a pane,
      // else fall back to the first step.
      var slugs = data.steps.map(function (s) {
        return this.slugify(s.stepName)
      }, this)
      slugs.push('land-owner')
      this.step = (this.tab && slugs.indexOf(this.tab) !== -1) ? this.tab : slugs[0]
    },

    // Tab text → URL slug: "Land Owner" → "land-owner", "New Submission" →
    // "new-submission". Strips chars that would break the d.<name>.<arg> grammar.
    slugify (text) {
      return String(text || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
    },

    tabClicked (tab) {
      // Reflect the active tab in the drawer URL (d.progress.<id>.<tab>).
      // replaceDrawerArgs is a safe no-op when `progress` is not in the route
      // (e.g. ProgressDetail rendered inline in ProgressReport/ProgressAction).
      if (tab && tab.name) {
        replaceDrawerArgs(this.$router, 'progress', { tab: tab.name })
      }
    }
  },

  data () {
    return {
      site: null,
      action: null,
      // Active el-tab slug — set definitively in fillStep once the step names
      // (and thus the pane slugs) are known. Seeded from the route slug here so
      // a deep-link has a value before the action resolves.
      step: this.tab || null
    }
  },

  created () {
    this.findSite(this.rowData.site_id, this.fillSite)
    this.fetchData('/actions/' + this.rowData.id, this.fillStep)
  }
}
</script>

<style scoped>
/*
 * ProgressDetail's plain-text labels (<span>/<b>/<i> with no explicit size)
 * inherit their font-size. On dev the component renders inside a table-cell /
 * form context that resets to 14px; in the progress drawer there is no such
 * reset, so they inherited the app's 19.2px body base and looked oversized
 * (XOL-231). Anchor the content base at 14px so the labels match dev in every
 * context. Absolute-sized headers (h1/h4) are unaffected; this is a no-op for
 * the inline ProgressReport / ProgressAction usages (already a 14px context).
 */
.progress-detail {
  font-size: 14px;
}
</style>
